// src/pages/NotFoundPage.js
import React from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Home as HomeIcon, Support as SupportIcon } from '@mui/icons-material';

const NotFoundPage = () => {
    return (
        <Container maxWidth="md" sx={{ py: 8 }}>
            <Paper elevation={3} sx={{ p: 5, textAlign: 'center' }}>
                <Typography variant="h1" color="primary" sx={{ fontSize: 120, fontWeight: 'bold', mb: 2 }}>
                    404
                </Typography>

                <Typography variant="h4" gutterBottom>
                    ¡Página no encontrada!
                </Typography>

                <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
                    Lo sentimos, la página que estás buscando no existe o ha sido movida.
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        to="/client/dashboard"
                        startIcon={<HomeIcon />}
                    >
                        Ir al inicio
                    </Button>

                    <Button
                        variant="outlined"
                        component={RouterLink}
                        to="/client/support"
                        startIcon={<SupportIcon />}
                    >
                        Contactar soporte
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default NotFoundPage;